import { useConfig } from '@/composables/config'
import { useAppStore } from '@/store/app-store'

export const CAMPAIGN_IDS = {
    FOOTER: 'footer',
    UNDER_GAME_ICON: 'under_game_icon',
    GAME_DESCRIPTION: 'game_description',
    PLAY_ON_APP_PROMO_BANNER: 'play_on_app_promo_banner',
}

export function useGoToApp(campaignId?: string) {
    const { VUE_APP_ANDROID_APP_URL, VUE_APP_IOS_APP_ADJUST_URL } = useConfig()
    const appStore = useAppStore()

    function goToApp() {
        if (appStore.platform === 'android') {
            const fallback = encodeURIComponent(VUE_APP_ANDROID_APP_URL)
            window.location.href = `intent://playgama.com${window.location.pathname}#Intent;scheme=https;package=com.playgama.twa;S.browser_fallback_url=${fallback};end`
        } else {
            let url = VUE_APP_IOS_APP_ADJUST_URL.replace('%PATH%', window.location.pathname)
            url = `${url}&adj_campaign=${campaignId}`
            window.open(url, '_blank')
        }
    }

    return { goToApp }
}
